import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Container, Grid, Segment, Header, Menu,  Dropdown, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import HradminEmployeeViewDetailsPage from './employee_view/details_page';
import HradminEmployeeViewUpdatePage from './employee_view/update_page';
import HradminEmployeeViewClaimsListPage from './employee_view/claims_list_page';
import HradminEmployeeViewClaimDetailOutPage from './employee_view/claim_detail_out_page';
import HradminEmployeeViewClaimDetailInpPage from './employee_view/claim_detail_inp_page';
import HradminEmployeeViewAddClaimPage from './employee_view/add_claim_page';
import HradminEmployeeViewAccessPage from './employee_view/access_page';

const HradminEmployeeViewPage = (props) =>{
    const {uuid} = props.match.params;
    return (
        <Container style={{paddingTop: 20}}>

            <Menu attached='top'>
                
                <Menu.Item header>Employee View Menu</Menu.Item>
                <Link to={`/hradmin/employees/${uuid}`}>
                    <Menu.Item
                        name='Information'
                        // active={activeItem === 'locations'}
                        // onClick={this.handleItemClick}
                    />
                </Link>
                <Dropdown item text="Claims" simple>
                    <Dropdown.Menu>
                        <Dropdown.Item>
                            <Link to={`/hradmin/employees/${uuid}/claims/list`}>View Claims</Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Link to={`/hradmin/employees/${uuid}/claims/add`}>Add Claim</Link>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <Link to={`/hradmin/employees/${uuid}/access`}>
                    <Menu.Item
                        name='Access'
                        // active={activeItem === 'locations'}
                        // onClick={this.handleItemClick}
                    />
                </Link>
            </Menu>

            <Segment attached>
                <Grid columns={1}>
                    <Grid.Column>
                        <Switch>
                            <Route exact path="/hradmin/employees/:uuid" component={HradminEmployeeViewDetailsPage} />
                            <Route exact path="/hradmin/employees/:uuid/update" component={HradminEmployeeViewUpdatePage} />
                            <Route exact path="/hradmin/employees/:uuid/claims/list" component={HradminEmployeeViewClaimsListPage} />
                            <Route exact path="/hradmin/employees/:uuid/claims/out/:claimTransactionNo" component={HradminEmployeeViewClaimDetailOutPage} />
                            <Route exact path="/hradmin/employees/:uuid/claims/inp/:claimTransactionNo" component={HradminEmployeeViewClaimDetailInpPage} />
                            <Route exact path="/hradmin/employees/:uuid/claims/add" component={HradminEmployeeViewAddClaimPage} />
                            <Route exact path="/hradmin/employees/:uuid/access" component={HradminEmployeeViewAccessPage} />
                        </Switch>
                    </Grid.Column>
                </Grid>
            </Segment>
        </Container>
    );
}

export default HradminEmployeeViewPage;

/*
<Dropdown item icon='wrench' text="Edit" simple>
    <Dropdown.Menu>
        <Dropdown.Item>
            <Icon name='dropdown' />
            <span className='text'>New</span>
            <Dropdown.Menu>
                <Dropdown.Item>Document</Dropdown.Item>
                <Dropdown.Item>Image</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown.Item>
        <Dropdown.Item>Open</Dropdown.Item>
        <Dropdown.Item>Save...</Dropdown.Item>
        <Dropdown.Item>Edit Permissions</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Header>Export</Dropdown.Header>
        <Dropdown.Item>Share</Dropdown.Item>
    </Dropdown.Menu>
</Dropdown>
*/